import RegisterPage from "src/page/Auth/RegisterPage"
import { IRoute } from "../interface/IRoute"
import StartPage from "../page/StartPage"
import LoginPage from "src/page/Auth/LoginPage"
import Cabinet from "src/page/Cabinet"
import TransactionPage from "src/page/TransactionPage"

export const privateRoutes: IRoute[] = [
  { path: '/cabinet', component: Cabinet } ,
  { path: '/transaction/:socketId', component: TransactionPage } ,
  
]

export const publikRoutes: IRoute[] = [
  { path: '/', component: StartPage } ,
  { path: '/register', component: RegisterPage } ,
  { path: '/login', component: LoginPage } ,
]